module.exports = __webpack_public_path__ + "img/respect.d02a528a.png";